export const FOOTER_ID = 'FOOTER_ID';
